import { useCallback, useState } from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { ApiErrors } from '../../enums';
import { usePostPaymentBankslipV2Mutation, usePostPaymentBilletMutation } from '../../services/billetApi';
import { mapBilletErrorToMessage } from '../../utils/errorMessages';
export function usePostPayBillet() {
    const [trigger] = usePostPaymentBilletMutation();
    const [triggerV2] = usePostPaymentBankslipV2Mutation();
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [errorNoFundsAvailable, setErrorNoFundsAvailable] = useState(false);
    const [errorMessagePostPayment, setErrorMessagePostPayment] = useState();
    const [billetInfo, setBilletInfo] = useState();
    const handlePostBilletError = useCallback((error) => {
        const errorMessage = mapBilletErrorToMessage(error, t);
        if (error.result?.errorCode === ApiErrors.NO_FUNDS_AVAILABLE ||
            error.result?.errorCode === ApiErrors.ERROR_NO_FUNDS_AVAILABLE) {
            setErrorNoFundsAvailable(true);
            return;
        }
        setErrorMessagePostPayment(errorMessage);
    }, [t]);
    const handleBilletSuccess = useCallback((data) => {
        setErrorMessagePostPayment(undefined);
        if (data?.result) {
            setBilletInfo(data.result);
        }
        else {
            setErrorMessagePostPayment(t('invalid-code-billet-not-found-error'));
        }
    }, [t]);
    const handleBankslipV2Success = useCallback((data) => {
        setErrorMessagePostPayment(undefined);
        if (data?.result) {
            setBilletInfo({
                amount: 0,
                dueDate: '',
                beneficiaryName: '',
                beneficiaryDocumentNumber: '',
                barCode: '',
                digitableLine: '',
                transactionId: data.result.transactionId,
            });
        }
        else {
            setErrorMessagePostPayment(t('invalid-code-billet-not-found-error'));
        }
    }, [t]);
    async function postPaymentBillet(value, isOperatorRequestPayment) {
        setLoading(true);
        setErrorMessagePostPayment(undefined);
        setBilletInfo(undefined);
        if (!value) {
            setLoading(false);
            return;
        }
        try {
            const { data, error } = await trigger({
                body: value,
                isOperatorRequestPayment,
            });
            if (error) {
                handlePostBilletError(error);
                return;
            }
            if (data) {
                handleBilletSuccess(data);
            }
        }
        catch (err) {
            handlePostBilletError(err);
        }
        finally {
            setLoading(false);
        }
    }
    async function postPaymentBankslipV2(value, isOperatorRequestPayment) {
        setLoading(true);
        setErrorMessagePostPayment(undefined);
        setBilletInfo(undefined);
        if (!value) {
            setLoading(false);
            return;
        }
        try {
            const { data, error } = await triggerV2({
                body: value,
                isOperatorRequestPayment,
            });
            if (error) {
                handlePostBilletError(error);
                return;
            }
            if (data) {
                handleBankslipV2Success(data);
            }
        }
        catch (err) {
            handlePostBilletError(err);
        }
        finally {
            setLoading(false);
        }
    }
    return {
        loading,
        billetInfo,
        errorMessagePostPayment,
        errorNoFundsAvailable,
        postPaymentBillet,
        postPaymentBankslipV2,
        setErrorNoFundsAvailable,
        setErrorMessagePostPayment,
    };
}
